export const Images = {
    logo: `${process.env.PUBLIC_URL}/images/listica-logo-white.svg`,
    usaFlag: `${process.env.PUBLIC_URL}/images/usa-flag.svg`,
    esFlag: `${process.env.PUBLIC_URL}/images/es-flag.svg`,
    tagLogo: `${process.env.PUBLIC_URL}/images/listica-tag-white.png`,
}

export default Images;